import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AuthorizationFormField } from './formField'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'
import { FlatAnswerMutation } from '../../../adapters/types'
import { AdapterOptions } from '../../../adapters/types'
import { getAnswerValuesFromItems } from '../../../helpers'
import { RocFormData } from '../../types/RocFormData'
import { RocAssessmentQuestionnaireItem } from '../../types/questionnaire'

/**
 * Authorization subsection adapter
 */
export class AuthorizationAdapter extends BaseSubsectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // TODO (ENG-5229): Make sure we support multiple authorization sources in the adapter
    const authorizationSource = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
    ).at(0)

    const currentHours = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS
    ).at(0)
    return {
      [AuthorizationFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE]: Array.isArray(
        authorizationSource
      )
        ? authorizationSource?.map((source) => source.reference)
        : authorizationSource?.reference,
      [AuthorizationFormField.AUTHORIZATION_CURRENT_HOURS]: currentHours
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    // TODO (ENG-5229): Make sure we support multiple authorization sources in the adapter
    if (
      this.formDataFieldExists(
        AuthorizationFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
      )
    ) {
      const authorizationSource = this.getFormDataField(
        AuthorizationFormField.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE
      )

      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE,
        value: Array.isArray(authorizationSource)
          ? authorizationSource?.map((source) => (source ? { reference: source } : undefined))
          : authorizationSource
          ? { reference: authorizationSource }
          : undefined
      })
    }

    if (this.formDataFieldExists(AuthorizationFormField.AUTHORIZATION_CURRENT_HOURS)) {
      const currentHours = this.getFormDataField(AuthorizationFormField.AUTHORIZATION_CURRENT_HOURS)

      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS,
        value: currentHours
      })
    }

    return mutations
  }
}
